import { useState } from 'react'
import PhoneInput from 'react-phone-input-2'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

// antd
import {
    Avatar,
    Card,
    Col,
    Form,
    Image,
    Input,
    message,
    Modal,
    Row,
    theme,
    Typography,
    Upload,
} from 'antd'
import { Icon } from '@iconify/react'

// assets
import { UploadImageIcon } from '../../../assets/icons'

// store
import {
    changeModel,
    masterDataAddDropDown,
    masterDataDropDownList,
    profileState,
} from '../../profile/profile.slice'
import { loginState } from '../../login/login.slice'

// constants
import { MASTER_DATA_FIELD } from '../../../constants/masterData'

// components
import ApiSelect from '../../../components/api-select/api-select'
import DropDownMultiple from '../../../components/dropDownMultiple'

// store
import { candidateCreateManually } from '../store/candidate.slice'
import {
    getJobApplicantListByStatus,
    getStatusWiseCount,
} from '../../jobApplications/store/jobApplicant.slice'

// constants
import {
    normalizePhoneNumber,
    PHONE_COUNTRIES,
} from '../../../constants/phone-countries'

import styles from '../../jobApplications/components/AddCandidate.module.css'

const ManuallyCandidateAdd = ({
    openManuallyModel,
    setOpenManuallyModel,
    fileURL,
    name = 'Meet',
    state: jobState,
}) => {
    const { id } = useParams()

    const [previewImage, setPreviewImage] = useState(null)
    const [searchValue, setSearchValue] = useState('')
    const [page, setPage] = useState(0)
    const [loadingStatus, setLoadingStatus] = useState('loading')
    const [isSubmitting, setIsSubmitting] = useState(false)

    const initialState = {
        phoneValid: false,
        phoneNumber: {
            default: null,
            phoneNo: null,
            code: null,
            flag: null,
        },
    }

    const [state, setState] = useState(initialState)

    const { userProfile } = useSelector(loginState)

    const { useToken } = theme
    const { token } = useToken()
    const { Text } = Typography
    const [form] = Form.useForm()
    const isReadOnly = false
    // SELECTORS
    const { formButtonType, masterDataDropDown, modelType, isNext } =
        useSelector(profileState)
    const dispatch = useDispatch()
    const fetchOptions = async (search = '', pageNumber = 1, model) => {
        setLoadingStatus('loading')
        setSearchValue(search)

        try {
            dispatch(changeModel(model))
            const result = await dispatch(
                masterDataDropDownList({
                    search: search,
                    id: model,
                    skip: pageNumber,
                })
            ).unwrap() // ⬅️ Get the actual payload

            const newData = Array.isArray(result?.data) ? result.data : []

            setPage(pageNumber + 1)
            setLoadingStatus(newData.length === 0 ? 'noData' : 'loaded')
        } catch (error) {
            console.error('Dropdown fetch failed', error)
            setLoadingStatus('noData')
        }
    }

    async function addMasterData() {
        const result = await dispatch(
            masterDataAddDropDown({
                addData: {
                    type: 'manual',
                    data: {
                        name: searchValue,
                        logo:
                            modelType === 'tools'
                                ? 'https://pms-bucket123.s3.amazonaws.com/Layer_1_1689237094.svg'
                                : modelType === 'institute'
                                ? 'https://pms-bucket123.s3.amazonaws.com/Group 35301_1689226177.svg'
                                : '',
                        createdBy: userProfile?._id,
                    },
                },
                model: modelType,
            })
        )
        const data = result?.payload?.data

        if (data) {
            const { success, message: errorMessage } = data
            if (success) {
                dispatch(
                    masterDataDropDownList({
                        search: searchValue,
                        id: modelType,
                    })
                )
            } else {
                if (errorMessage) {
                    message.error(errorMessage)
                } else {
                    message.error('Something went wrong, try again later.')
                }
            }
        }
    }
    const resetPage = () => {
        setPage(1)
    }

    const extractValue = (input) => {
        if (Array.isArray(input)) return input.map((i) => i?.value || i)
        if (input && typeof input === 'object') return input.value || input
        return input
    }

    const handleCreateCandidate = async () => {
        try {
            setIsSubmitting(true)
            const values = await form.validateFields()

            let phoneNumber = values?.phone || ''
            if (
                phoneNumber.startsWith(values?.primaryContactNumberCountryCode)
            ) {
                phoneNumber = phoneNumber.replace(
                    values.primaryContactNumberCountryCode,
                    ''
                )
            }

            const response = await dispatch(
                candidateCreateManually({
                    profilePicture: previewImage,
                    fullName: values.name,
                    personalEmail: values.email,
                    primaryContactNumber: phoneNumber,
                    primaryContactNumberCountryCode:
                        values?.primaryContactNumberCountryCode,
                    primaryContactNumberCountryFlag:
                        values?.primaryContactNumberCountryFlag,
                    totalExperience: Number(values.totalExperience),
                    designation: extractValue(values?.designation),
                    status: 'applied',
                    jobId: id,
                    isAddedByAI: false,
                })
            )

            const data = response?.payload?.data

            if (data) {
                if (data?.success) {
                    message.success('Candidate created successfully')
                    setOpenManuallyModel(false)
                    form.resetFields()
                    setPreviewImage(null)
                    dispatch(
                        getJobApplicantListByStatus({
                            filter: {
                                job: id,
                                status: jobState?.jobStatus || 'applied',
                            },
                        })
                    )
                    dispatch(getStatusWiseCount({ jobId: id }))
                } else {
                    if (data?.message) {
                        message.error(data?.message?.error || data?.message)
                    } else {
                        message.error('Something went wrong, try again later.')
                    }
                }
            }
        } catch (error) {
            setIsSubmitting(false)
            console.error('Form validation failed:', error)
            // message.error("Please fill in all required fields correctly.");
        } finally {
            setIsSubmitting(false)
        }
    }
    return (
        <Modal
            title={
                <div className={styles.modalHeader}>
                    <div className={styles.modalHeaderLeft}>
                        <div className={styles.modalHeaderIcon}>
                            <Icon
                                icon="mdi:account-plus-outline"
                                width={20}
                                height={20}
                            />
                        </div>
                        <div>
                            <div className={styles.modalHeaderTitle}>
                                Add Candidate
                            </div>
                            <div className={styles.modalHeaderSubtitle}>
                                Enter candidate details manually
                            </div>
                        </div>
                    </div>
                </div>
            }
            open={openManuallyModel}
            onCancel={() => setOpenManuallyModel(false)}
            width={790}
            className={styles.candidateModal}
            destroyOnClose
            centered
            maskClosable={!isSubmitting}
            closable={!isSubmitting}
            footer={
                <div className={styles.modalFooter}>
                    <div className={styles.formActions}>
                        <button
                            type="button"
                            onClick={() => setOpenManuallyModel(false)}
                            disabled={isSubmitting}
                            className={styles.cancelButton}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={() => handleCreateCandidate()}
                            disabled={isSubmitting}
                            className={`${styles.submitButton} ${
                                isSubmitting ? styles.submitButtonDisabled : ''
                            }`}
                        >
                            {isSubmitting ? (
                                <>
                                    <Icon
                                        icon="line-md:loading-loop"
                                        width={16}
                                        height={16}
                                        className={styles.submitSpinner}
                                    />
                                    Creating...
                                </>
                            ) : (
                                'Create'
                            )}
                        </button>
                    </div>
                </div>
            }
        >
            <div className={styles.modalBody}>
                <Form
                    labelCol={{
                        style: {
                            padding: '0 0 3px',
                        },
                    }}
                    layout="vertical"
                    name="talentDataForm"
                    form={form}
                    requiredMark={true}
                    style={{
                        overflowX: 'hidden',
                    }}
                >
                    <Row gutter={15}>
                        <Col span={12}>
                            <Card
                                className={`${styles.profileCard} manually-candidate-add-profile`}
                                bordered={false}
                            >
                                <div className="candidate_upload_profile">
                                    <Upload
                                        listType="picture-circle"
                                        className="avatar-uploader-candidate-details"
                                        showUploadList={false}
                                        accept=".png,.jpg,.jpeg"
                                        beforeUpload={(file) => {
                                            const isImage =
                                                file.type.startsWith('image/')
                                            if (isImage) {
                                                const imageUrl =
                                                    URL.createObjectURL(file)
                                                setPreviewImage(imageUrl)
                                            }
                                            return false // prevent auto upload
                                        }}
                                    >
                                        {previewImage ? (
                                            <Image
                                                src={previewImage}
                                                preview={false}
                                                style={{
                                                    height: '128px',
                                                    width: '128px',
                                                    borderRadius: '50%',
                                                }}
                                            />
                                        ) : fileURL?.length > 0 ? (
                                            <Image
                                                src={fileURL[0]}
                                                preview={false}
                                                style={{
                                                    height: '128px',
                                                    width: '128px',
                                                    borderRadius: '50%',
                                                }}
                                            />
                                        ) : (
                                            <Avatar size={128}>
                                                {name
                                                    ? name
                                                          .trim()[0]
                                                          .toUpperCase()
                                                    : name
                                                          .trim()[0]
                                                          ?.toUpperCase() || ''}
                                            </Avatar>
                                        )}

                                        <div className="hoverLayer">
                                            <div className="hoverShow">
                                                <UploadImageIcon />
                                                <div
                                                    style={{
                                                        marginTop: 8,
                                                        color: '#fff',
                                                    }}
                                                >
                                                    Update Profile
                                                </div>
                                            </div>
                                        </div>
                                    </Upload>
                                </div>
                                <Row>
                                    <Text
                                        className={styles.profileHint}
                                        style={{
                                            fontSize: token.fontSizeIcon,
                                        }}
                                    >
                                        Allowed *.jpeg, *.jpg, *.png, Max size
                                        of 5 MB
                                    </Text>
                                </Row>
                            </Card>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Name"
                                name="name"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Name is required',
                                    },
                                ]}
                            >
                                <Input
                                    placeholder="Full Name"
                                    size="large"
                                    disabled={isReadOnly}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Email"
                                name="email"
                                style={{ marginTop: '10px' }}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Email is required',
                                    },
                                    {
                                        type: 'email',
                                        message: 'Enter a valid email',
                                    },
                                ]}
                            >
                                <Input
                                    placeholder="Email"
                                    size="large"
                                    disabled={isReadOnly}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Phone Number"
                                name="phone"
                                rules={[
                                    {
                                        validator: async () => {
                                            const phone =
                                                form.getFieldValue('phone') ||
                                                ''
                                            const countryCode =
                                                form.getFieldValue(
                                                    'primaryContactNumberCountryCode'
                                                ) || ''

                                            const dialCode =
                                                countryCode.replace('+', '')

                                            let numberWithoutCode =
                                                phone.startsWith(dialCode)
                                                    ? phone.slice(
                                                          dialCode.length
                                                      )
                                                    : phone

                                            if (
                                                !state?.phoneValid &&
                                                numberWithoutCode.length > 0
                                            ) {
                                                return Promise.reject(
                                                    new Error(
                                                        'Please Enter a valid Phone Number'
                                                    )
                                                )
                                            }

                                            if (
                                                numberWithoutCode.length === 0
                                            ) {
                                                return Promise.reject(
                                                    new Error(
                                                        'Please Enter Phone Number'
                                                    )
                                                )
                                            }

                                            return Promise.resolve()
                                        },
                                    },
                                ]}
                                style={{ marginTop: '10px' }}
                            >
                                <PhoneInput
                                    inputStyle={{ width: '100%' }}
                                    specialLabel=""
                                    onlyCountries={[]}
                                    country={'in'}
                                    enableSearch={true}
                                    countryCodeEditable={false}
                                    value={form.getFieldValue('phone')}
                                    onChange={(number, country) => {
                                        form.setFieldsValue({
                                            primaryContactNumberCountryCode: `+${country.dialCode}`,
                                            primaryContactNumberCountryFlag:
                                                country.countryCode.toUpperCase(),
                                        })

                                        const correspondingCountry =
                                            PHONE_COUNTRIES.find(
                                                (c) =>
                                                    c.iso2 ===
                                                    country.countryCode?.toUpperCase()
                                            )

                                        let numberNew = normalizePhoneNumber(
                                            `+${number}`,
                                            {
                                                iso2: country.countryCode?.toUpperCase(),
                                                dialCode: country.dialCode,
                                            }
                                        )

                                        if (
                                            correspondingCountry?.validation.test(
                                                numberNew
                                            )
                                        ) {
                                            setState((prevState) => ({
                                                ...prevState,
                                                phoneValid: true,
                                            }))
                                        } else {
                                            setState((prevState) => ({
                                                ...prevState,
                                                phoneValid: false,
                                            }))
                                        }
                                    }}
                                />
                            </Form.Item>
                            <Form.Item
                                name="primaryContactNumberCountryCode"
                                hidden
                            >
                                <Input type="hidden" />
                            </Form.Item>

                            <Form.Item
                                name="primaryContactNumberCountryFlag"
                                hidden
                            >
                                <Input type="hidden" />
                            </Form.Item>

                            <div style={{ marginTop: '10px' }}>
                                <ApiSelect
                                    label="Designation"
                                    name={MASTER_DATA_FIELD.designation}
                                    disabled={isReadOnly}
                                    rules={
                                        formButtonType !== 'draftButtonLoading'
                                            ? [
                                                  {
                                                      required: true,
                                                      message:
                                                          'Designation is required',
                                                  },
                                              ]
                                            : []
                                    }
                                    placeholder="Designation"
                                    onClick={() => {
                                        resetPage()
                                        fetchOptions(
                                            '',
                                            0,
                                            MASTER_DATA_FIELD.designation
                                        )
                                    }}
                                    onSearch={(value) => {
                                        resetPage()
                                        fetchOptions(
                                            value,
                                            0,
                                            MASTER_DATA_FIELD.designation
                                        )
                                    }}
                                    onScrollBottom={() => {
                                        fetchOptions(
                                            searchValue,
                                            page,
                                            MASTER_DATA_FIELD.designation
                                        )
                                    }}
                                    dropdownRender={(menu, handleScroll) => (
                                        <DropDownMultiple
                                            handleScroll={handleScroll}
                                            menu={menu}
                                            searchValue={searchValue}
                                            name={MASTER_DATA_FIELD.designation}
                                            addMasterData={() =>
                                                addMasterData()
                                            }
                                        />
                                    )}
                                    options={masterDataDropDown?.designation}
                                    dropdownStatus={loadingStatus}
                                    isNext={isNext}
                                    rootClassName="select-search-job"
                                />
                            </div>

                            <Form.Item
                                label="Total Experience"
                                name="totalExperience"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Experience is required',
                                    },
                                    {
                                        validator: (_, value) => {
                                            if (!value) return Promise.resolve() // required handles empty
                                            const number = parseFloat(value)
                                            if (isNaN(number) || number < 0) {
                                                return Promise.reject(
                                                    'Enter a valid number'
                                                )
                                            }
                                            if (
                                                !/^\d{1,3}(\.\d?)?$/.test(value)
                                            ) {
                                                return Promise.reject(
                                                    'Max 4 characters (e.g., 3.5 or 10.0)'
                                                )
                                            }
                                            return Promise.resolve()
                                        },
                                    },
                                ]}
                                style={{ marginTop: '10px' }}
                            >
                                <Input
                                    placeholder="Total Experience"
                                    size="large"
                                    disabled={isReadOnly}
                                    type="text"
                                    inputMode="decimal"
                                    maxLength={4} // just for safety, UI-level
                                    onKeyPress={(e) => {
                                        const key = e.key
                                        const value = e.currentTarget.value

                                        const isDigit = /[0-9]/.test(key)
                                        const isDot = key === '.'
                                        const alreadyHasDot =
                                            value.includes('.')

                                        // Prevent dot as the first character
                                        if (value === '' && isDot) {
                                            e.preventDefault()
                                            return
                                        }

                                        // Only allow digits and one dot
                                        if (
                                            !isDigit &&
                                            !(isDot && !alreadyHasDot)
                                        ) {
                                            e.preventDefault()
                                            return
                                        }

                                        // Prevent more than 4 characters total
                                        if (
                                            value.length >= 4 &&
                                            !e.currentTarget.selectionStart !==
                                                value.length
                                        ) {
                                            e.preventDefault()
                                        }
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </div>
        </Modal>
    )
}

export default ManuallyCandidateAdd
